@if (data.title!=null && data.title!='') {
  <h1 mat-dialog-title>{{data.title}}</h1>
}
<div mat-dialog-content>
  <p>{{data.text}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="1" class="btn btn-primary" cdkFocusInitial>Si</button>
  <button mat-button (click)="onNoClick()" class="btn btn-light">No</button>
</div>